import { createContext, useContext, useEffect, useState } from "react"
import {
    collection,
    query,
    where,
    getDocs,
    orderBy,
    limit,
    startAfter, 
    and,
    or
} from "firebase/firestore"
import { db } from "../firebase"
import { start } from "@cloudinary/url-gen/qualifiers/textAlignment"

const ListingContext = createContext()
const ListingUpdateContext = createContext()

export function useListingsContext() {
    return useContext(ListingContext)
}

export function useListingsUpdate() {
    return useContext(ListingUpdateContext)
}

export const ListingContextProvider = ({ children }) => {
    const [listings, setListings] = useState(null)
    const [lastVisible, setLastVisible] = useState(null)
    const [hasMore, setHasMore] = useState(true)
    const listingsPerPage = 6;

    const getListings = async(searchFilter="", categoryFilter="All", locationFilter="") => {
        if (!hasMore) {
            return
        }
        try {
            let listingsCollection = collection(db, "listings")
            let q = query(listingsCollection, where("active", "==", true));
            let filterArray

            // Programmatically add WHERE clauses based on filter selections
            if (searchFilter !== "") {
                const filterSplit = searchFilter.toLowerCase().split(/[\s.,!~/-]/)
                filterArray = [...new Set([...filterSplit, searchFilter])]
                q = query(q, or(
                        where("titleTags", "array-contains-any", filterArray),
                        where("descriptionTags", "array-contains-any", filterArray),
                        where("aiTags", "array-contains-any", filterArray)
                        // where("searchArray", "array-contains-any", filterArray)
                    ));
                
            }

            if (categoryFilter !== 'All') {
                q = query(q, where('category', '==', categoryFilter));
            }

            if (locationFilter !== "") {
                q = query(q, where('location', '==', locationFilter));
            }

            // let q
            // let andClause
            // let filterArray
            // if (searchFilter) {
            //     const filterSplit = searchFilter.toLowerCase().split(/[\s.,!~/-]/)
            //     filterArray = [...new Set(filterSplit)]
            // }

            // if (searchFilter && categoryFilter) {
            //     andClause = and(
            //         where("active", "==", true), 
            //         where("searchArray", "array-contains-any", filterArray),
            //         where("category", "==", categoryFilter)
            //     )  
            // } else if (searchFilter) {
            //     andClause =  and(
            //         where("active", "==", true), 
            //         where("searchArray", "array-contains-any", filterArray),
            //     )  
            // } else if (categoryFilter) {
            //     andClause =  and(
            //         where("active", "==", true), 
            //         where("category", "==", categoryFilter)
            //     )  
            // }
            // console.log(andClause)

            if (!lastVisible) {
                // if(searchFilter || categoryFilter) {
                //     console.log(searchFilter)
                //     const filterSplit = searchFilter.toLowerCase().split(/[\s.,!~/-]/)
                //     const filterArray = [...new Set(filterSplit)]
                //     q = query(
                //         listingsCollection, 
                //         andClause,
                //         // and(
                //         //     where("active", "==", true), 
                //         //     where("searchArray", "array-contains-any", filterArray)
                //         // ),
                //         orderBy("createdAt", "desc"), 
                //         limit(listingsPerPage),
                //     )
                // } else {
                //     q = query(
                //         listingsCollection, 
                //         where("active", "==", true),
                //         orderBy("createdAt", "desc"), 
                //         limit(listingsPerPage),
                //     )
                // }
                q = query(
                    q,
                    orderBy("createdAt", "desc"), 
                    limit(listingsPerPage),
                )
            } else {
                // if(searchFilter || categoryFilter) {
                //     // const filterSplit = searchFilter.toLowerCase().split(/[\s.,!~/-]/)
                //     // const filterArray = [...new Set(filterSplit)]
                //     q = query(
                //         listingsCollection, 
                //         andClause,
                //         // and(
                //         //     where("active", "==", true), 
                //         //     where("searchArray", "array-contains-any", filterArray)
                //         // ),
                //         orderBy("createdAt", "desc"), 
                //         limit(listingsPerPage),
                //         startAfter(lastVisible)
                //     )
                // } else {
                //     q = query(
                //         listingsCollection, 
                //         where("active", "==", true), 
                //         orderBy("createdAt", "desc"), 
                //         limit(listingsPerPage),
                //         startAfter(lastVisible)
                //     )
                // }
                q = query(
                    q,
                    orderBy("createdAt", "desc"), 
                    limit(listingsPerPage),
                    startAfter(lastVisible)
                )
            }
            console.log(q)
            console.log('querying listings')
            const querySnapshot = await getDocs(q)
            if (querySnapshot.docs.length === 0) {
                console.log('nomore')
                setHasMore(false)
                return
            }

            const queryRes = []
            querySnapshot.forEach((doc) => {
                const docData = doc.data()
                docData.listing_id = doc.id
                // console.log(docData)
                queryRes.push(docData)
            })
            console.log(queryRes)

            setListings(prevListings => {
                if (prevListings && queryRes.length > 0) {
                    return [...prevListings, ...queryRes]
                } else if (queryRes.length > 0) {
                    return [...queryRes]
                } else {
                    return null
                }
            }
            )
            setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1])
            console.log(queryRes)
            console.log(querySnapshot.docs[querySnapshot.docs.length - 1])
        } catch(err) {
            console.error(err.message)
        }
    }

    const updateListings = (newListingsArray) => {
        setListings(newListingsArray)
        console.log("listings updated to", newListingsArray)
    }

    // useEffect(() => {
    //     getListings()
    // }, [])

    return (
        <ListingContext.Provider value={ {listings, updateListings, getListings, hasMore, setHasMore, setLastVisible, setListings} }>
            {children}
        </ListingContext.Provider>
    )

}